"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const src_1 = require("@rover/ts-bootstrap/dist/src");
const MOBILE_STYLING = {
    minHeight: 72,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingTop: 24,
    paddingBottom: 23,
    borderBottom: `1px solid ${src_1.titanium}`,
};
const NON_MOBILE_STYLING = {
    display: 'flex',
    height: 55,
    marginRight: 16,
    marginLeft: 16,
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottom: `1px solid ${src_1.titanium}`,
};
const DeviceList = ({ selectedDeviceIds, userDeviceType, devices, handleSelectDevice }) => {
    return (React.createElement(React.Fragment, null, devices.map((dev, index) => (React.createElement("div", { style: userDeviceType === 'Mobile' ? MOBILE_STYLING : NON_MOBILE_STYLING, key: dev.deviceIdentifier, onClick: () => handleSelectDevice(dev.deviceIdentifier) },
        React.createElement(src_1.Text, { text: dev.deviceName, size: userDeviceType !== 'Mobile' ? 'medium' : 'large', textStyle: {
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
            } }),
        React.createElement("div", { style: {
                marginLeft: 10,
                display: 'flex',
                alignItems: 'flex-end',
            } },
            React.createElement(src_1.Text, { size: "small", text: dev.deviceIdentifier.slice(0, 8), textStyle: {
                    color: src_1.titanium,
                    marginRight: 8,
                } }),
            React.createElement(src_1.CheckBox, { checked: selectedDeviceIds.includes(dev.deviceIdentifier), onClick: () => null })))))));
};
exports.default = DeviceList;
